import * as React from 'react';
import { SVGProps } from 'react';

const IconColumnsSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2h2v8H2V2ZM5 2h2v8H5V2ZM8 2h2v8H8V2Z" />
  </svg>
);
export default IconColumnsSizeXs;
